import { Component } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  constructor() {}

  blockTextAbout = {
    heading: 'About The Vibranium Society - Help and information',
    content: [
      '<b>What is this?</b><br> This site allows you to play Keyforge Adventures, a cooperative Deck Building Game from Fantasy Flight Games (FFG) in your browser.',
      '<b>How to submit an issue ?</b><br>Submit an issue : <a class="button" href="https://github.com/theambersociety/keyforge-adventures/issues" target="_blank"><button>click on this link</button></a>',
      '<b>Additional Notes</b><br> The Keyforge Cards, Game, the artwork and many other things are all copyright Fantasy Flight Games and I make no claims of ownership or otherwise of any of the artwork or trademarks. This site exists for passionate fans to play a game they enjoy and augment, rather than replace, the in person LCG. FFG does not endorse, support, and is not involved with, this site in any way.',
      `<b>Who are you ? </b><br>My name is Staelen, i\'m a front enthusiastic developper. I like to code personnal projects. Im a big fan of card games.`,
      '<b>How to contact me ? </b><br> You can send me a message to <a href="mailto:theamberociety@gmail.com">thevibraniumsociety@gmail.com</a>'
    ]
    // action: 'Play'
  };

  blockTextRoadmap = {
    heading: 'Road-Map 2020-2021',
    content: [
      '<b>What is this?</b><br> The roadmap shows the incoming evolutions of the vibranium society.',
      '<b>How it works?</b><br> To be honest, this app take me a lot of time ,I try to make something great and I hope a lot of people will enjoy it. But there is no guarantee the app will be liked and used. So instead of develop something for nothing, I prefer give you a sample of what it could be and then watch if the app is used to continue its development.<br>I have defined pallies for the next features, and you can unlock their development by showing your support (facebook, twitter or just play the game, send messages etc).',
      `<b>Pallies 🐤 :</b><br>
      - &nbsp;&nbsp;&nbsp;&nbsp;10 likes  (🔒) : Thanks ! You make a developper happy<br>
      - &nbsp;&nbsp;&nbsp;&nbsp;50 likes (🔒) : Add all default bosses with various levels !<br>
      - &nbsp;&nbsp;150 likes (🔒) : Deck generator (simple version) !<br>
      - &nbsp;&nbsp;250 likes (🔒) : Custom villains event from community !<br>
      - &nbsp;&nbsp;500 likes (🔒) : Deck generator (advanced version) !<br>
      - 1000 likes (🔒) : Badges and track your games !<br>
      - 2000 likes (🔒) : Solve challenges puzzles !<br>
      And more...
      `
    ]
    // action: 'Play' 🆗
  };
}
